import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';

const useStateWithDebounce = <T = unknown>(
  initialState: T,
  wait = 200,
): [T, React.Dispatch<React.SetStateAction<T>>, T] => {
  const [state, setState] = useState(initialState);

  const [debouncedValue] = useDebouncedValue(state, wait, { leading: true });

  return [state, setState, debouncedValue];
};

export default useStateWithDebounce;
